import {styled} from '@mui/material/styles';
import {TableSortLabel} from '@mui/material';

export const StyledTableSortLabel = styled(TableSortLabel)(({theme}) => ({
  color: theme.palette.text.primary,
  '&:hover': {
    color: theme.palette.success.main,
  },
  '&.Mui-active': {
    color: theme.palette.text.destructive,
  },

  '&.Mui-active .MuiTableSortLabel-icon': {
    color: theme.palette.text.destructive,
  },

  '& .MuiTableSortLabel-icon': {
    color: theme.palette.success.main,
  },
}));
